module.exports = __webpack_public_path__ + "img/vector-tanks-extreme-screenshot (1).5234a006.jpg";